import React from 'react';
import { MenuSideNavProps } from './SupportSideNav.interface';
import { Divider } from '@zurich-primitives/divider';
import { useNavigate } from 'react-router-dom';
import { openFeedbackEmail } from 'app/utils';
import {
  useAppDispatch,
  useAppSelector,
  setCurrentSupportPath,
  getCurrentSupportPath
} from 'app/redux';
import styles from './SupportSideNav.module.scss';

export const menuSideBar: MenuSideNavProps[] = [];

export const SupportSideNav: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const currentSupportPath = useAppSelector(getCurrentSupportPath);
  const sections: Array<{ name: string; path: string; active?: boolean }> = [
    {
      name: 'Don’t find what you are looking for',
      path: 'something-missing',
      active: currentSupportPath === 'something-missing'
    },
    {
      name: 'Give us Feedback',
      path: 'feedback',
      active: currentSupportPath === 'feedback'
    }
  ];

  const navSupportPath = (path: string): void => {
    dispatch(setCurrentSupportPath(path));
    navigate(path);
  };
  return (
    <nav className={`${styles['side-navigation']}`}>
      <div className={styles.header}>
        <h2 className="highlight">Support Hub</h2>
        <p className={`body-sm-r`}>
          Everything you need to know about GenAI Business Services
        </p>
      </div>

      <div className={styles.sections}>
        {sections.map((section) => (
          <div
            className={`${styles.section} ${
              section.active === true ? styles.active : ''
            }`}
            key={`support-section-${section.path}`}
            role="button"
            onClick={() => {
              navSupportPath(section.path);
            }}
            tabIndex={0}
          >
            {section.name}
          </div>
        ))}
        <Divider medium />
        <div
          className={`${styles.section}`}
          role="button"
          onClick={openFeedbackEmail}
          tabIndex={0}
        >
          Get Assistance
        </div>
      </div>
    </nav>
  );
};
